import 'react';
import { jsx } from 'react/jsx-runtime';

/**
 * Create visual height for content
 */
const Filler = ({
  height,
  offset,
  children
}) => {
  let outerStyle = {};
  let innerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };
  if (offset !== undefined) {
    outerStyle = {
      height,
      position: 'relative',
      zIndex: 0
    };
    innerStyle = {
      ...innerStyle,
      transform: `translateY(${offset}px)`,
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0
    };
  }
  return /*#__PURE__*/jsx("div", {
    style: outerStyle,
    children: /*#__PURE__*/jsx("div", {
      style: innerStyle,
      children: children
    })
  });
};

export { Filler };
